module.exports = __webpack_public_path__ + "static/media/plate2Img2.3fadcb58.png";